<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'chargeInformation.chargeType' | translate }}</label>
    <input type="text" appInput [value]="getTranslatedChargeType()" readonly>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'chargeInformation.chargeTypeId' | translate }}</label>
    <input type="text" appInput formControlName="chargeTypeId" readonly>
  </app-input-group>
  @if (form.get('chargeType')?.value === 'Subscription') {
    <app-input-group>
      <label appLabel>{{ 'chargeInformation.chargeOccurrences' | translate }}</label>
      <input type="number" appInput formControlName="chargeOccurrences">
    </app-input-group>
  }
  <app-input-group>
    <label appLabel>{{ 'chargeInformation.validFrom' | translate }}</label>
    <input type="date" appInput formControlName="validFrom">
  </app-input-group>

</form>
